









import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ToAdd } from "@/ts/Types";
import SpanishText from "@/components/SpanishText.vue";
@Component({
  components: {
    SpanishText
  }
})
export default class EntryEditor extends Vue {
  @Prop() private toAdd!: ToAdd;
  @Prop() public prop2!: string;

  @Watch("toAdd")
  onPropertyChanged(value: string, oldValue: string) {
    console.log("toadd changed from:", oldValue, "to", value);
  }

  mounted() {
    // console.log("mounted with:", this.toAdd);
    // console.log("prop2", this.prop2);
  }
  deleteMe() {
    console.log("emitting delete:", this.toAdd);
    this.$emit("deleted", this.toAdd);
  }
}
